import React, { useState } from 'react';

const UserProfile: React.FC = () => {
    const [user, setUser] = useState({
        name: 'Benedikt Beumker',
        email: 'benedikt@example.com',
        company: 'Tech Solutions GmbH',
        role: 'Administrator',
        bio: 'Experte für KI und Chatbot-Entwicklung.',
        notifications: {
            email: true,
            push: false,
            weekly_report: true
        }
    });

    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState(user);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        if (type === 'checkbox') {
            const checked = (e.target as HTMLInputElement).checked;
            setFormData({
                ...formData,
                notifications: {
                    ...formData.notifications,
                    [name.replace('notifications_', '')]: checked
                }
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setUser(formData);
        setIsEditing(false);
        // Hier würde ein API-Aufruf erfolgen, um Änderungen zu speichern
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-gray-900">Dein Profil</h1>
                {!isEditing && (
                    <button
                        onClick={() => setIsEditing(true)}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        Profil bearbeiten
                    </button>
                )}
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden">
                {!isEditing ? (
                    <div className="p-6">
                        <div className="flex items-center mb-6">
                            <img
                                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                alt={user.name}
                                className="w-20 h-20 rounded-full mr-4"
                            />
                            <div>
                                <h2 className="text-2xl font-bold text-gray-900">{user.name}</h2>
                                <p className="text-gray-600">{user.email}</p>
                                <p className="text-gray-500 text-sm mt-1">{user.role} bei {user.company}</p>
                            </div>
                        </div>

                        <div className="border-t border-gray-200 pt-4 mt-4">
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Über mich</h3>
                            <p className="text-gray-600">{user.bio || 'Keine Biographie vorhanden.'}</p>
                        </div>

                        <div className="border-t border-gray-200 pt-4 mt-4">
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Benachrichtigungseinstellungen</h3>
                            <ul className="space-y-2">
                                <li className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${user.notifications.email ? 'text-green-500' : 'text-gray-400'}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d={user.notifications.email ? "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" : "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"} clipRule="evenodd" />
                                    </svg>
                                    <span className="ml-2">E-Mail-Benachrichtigungen</span>
                                </li>
                                <li className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${user.notifications.push ? 'text-green-500' : 'text-gray-400'}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d={user.notifications.push ? "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" : "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"} clipRule="evenodd" />
                                    </svg>
                                    <span className="ml-2">Push-Benachrichtigungen</span>
                                </li>
                                <li className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${user.notifications.weekly_report ? 'text-green-500' : 'text-gray-400'}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d={user.notifications.weekly_report ? "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" : "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"} clipRule="evenodd" />
                                    </svg>
                                    <span className="ml-2">Wöchentliche Berichte</span>
                                </li>
                            </ul>
                        </div>

                        <div className="border-t border-gray-200 pt-4 mt-4">
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Sicherheit</h3>
                            <div className="flex space-x-4">
                                <button className="text-blue-500 hover:text-blue-700 text-sm font-medium">
                                    Passwort ändern
                                </button>
                                <button className="text-blue-500 hover:text-blue-700 text-sm font-medium">
                                    Zwei-Faktor-Authentifizierung einrichten
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-6">
                        <div className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-Mail</label>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="company" className="block text-sm font-medium text-gray-700">Unternehmen</label>
                                <input
                                    type="text"
                                    name="company"
                                    id="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            <div>
                                <label htmlFor="bio" className="block text-sm font-medium text-gray-700">Über mich</label>
                                <textarea
                                    name="bio"
                                    id="bio"
                                    rows={3}
                                    value={formData.bio}
                                    onChange={handleChange}
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                ></textarea>
                            </div>

                            <div>
                                <h3 className="text-sm font-medium text-gray-700 mb-3">Benachrichtigungseinstellungen</h3>
                                <div className="space-y-2">
                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input
                                                id="notifications_email"
                                                name="notifications_email"
                                                type="checkbox"
                                                checked={formData.notifications.email}
                                                onChange={handleChange}
                                                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                                            />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="notifications_email" className="font-medium text-gray-700">E-Mail-Benachrichtigungen</label>
                                            <p className="text-gray-500">Erhalte Benachrichtigungen per E-Mail über neue Aktivitäten.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input
                                                id="notifications_push"
                                                name="notifications_push"
                                                type="checkbox"
                                                checked={formData.notifications.push}
                                                onChange={handleChange}
                                                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                                            />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="notifications_push" className="font-medium text-gray-700">Push-Benachrichtigungen</label>
                                            <p className="text-gray-500">Erhalte Push-Benachrichtigungen im Browser.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input
                                                id="notifications_weekly_report"
                                                name="notifications_weekly_report"
                                                type="checkbox"
                                                checked={formData.notifications.weekly_report}
                                                onChange={handleChange}
                                                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                                            />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="notifications_weekly_report" className="font-medium text-gray-700">Wöchentliche Berichte</label>
                                            <p className="text-gray-500">Erhalte wöchentliche Zusammenfassungen zu deinen Chatbots.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-end space-x-3">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setIsEditing(false);
                                        setFormData(user);
                                    }}
                                    className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                    Abbrechen
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    Änderungen speichern
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default UserProfile;